var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (!_vm.isUserCollect)?_c('div',{directives:[{name:"log",rawName:"v-log",value:({
        type: 'show',
        name: 'CARD',
        value: {
            card_type: 'guess_you_may_like',
        },
    }),expression:"{\n        type: 'show',\n        name: 'CARD',\n        value: {\n            card_type: 'guess_you_may_like',\n        },\n    }"}],staticClass:"guess-warp"},[_c('div',{staticClass:"title"},[_vm._v("\n        "+_vm._s(_vm.$t('k_460891'))+"\n    ")]),_vm._v(" "),_c('div',{staticClass:"list"},_vm._l((_vm.list),function(item){return _c('div',{directives:[{name:"log",rawName:"v-log",value:({
                type: 'show',
                name: 'GUESS_YOU_MAY_LIKE',
                value: {
                    result: item,
                },
            }),expression:"{\n                type: 'show',\n                name: 'GUESS_YOU_MAY_LIKE',\n                value: {\n                    result: item,\n                },\n            }"}],key:item,staticClass:"item",on:{"click":() => _vm.handleGuessCard(item)}},[_c('span',[_vm._v(_vm._s(item))])])}),0)]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }